import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/24/solid';
import Button from './Button';

// displays a card of a fixed size with grey blurred background and a closing button
// pass the function meant to close the overlay as closeCallback
// if it needs to keep its height fixed, pass fixedHeight as true
export default function OverlayCard({ children, closeCallback }) {
  const { t } = useTranslation('app', { keyPrefix: 'general' });

  return (
    // pb-12 in small layouts prevents the card overlapping with the Feedback button
    <div id="overlayCard" className="absolute w-full h-full flex items-start z-50 top-0 left-0 pb-12 md:pb-8 md:p-8 bg-gray-300 bg-opacity-90 space-y-6 overflow-y-auto xs:overflow-none" role="dialog">
      <div className="bg-gray-50 shadow h-auto rounded-sm m-auto w-full lg:max-w-4xl">
        <Button onClick={closeCallback} formatting="absolute top-0 right-0 m-4 hidden sm:inline" Icon={XMarkIcon} noFrame />
        <Button onClick={closeCallback} formatting="absolute top-0 right-0 m-4 sm:hidden" text={t('close')} />
        {children}
      </div>
    </div>
  );
}
OverlayCard.propTypes = {
  children: PropTypes.node.isRequired,
  closeCallback: PropTypes.func,
};
OverlayCard.defaultProps = {
  closeCallback: () => {},
};
